import { render, staticRenderFns } from "./AlternativeListItem.vue?vue&type=template&id=0ef8a178&scoped=true"
import script from "./AlternativeListItem.vue?vue&type=script&lang=js"
export * from "./AlternativeListItem.vue?vue&type=script&lang=js"
import style0 from "./AlternativeListItem.vue?vue&type=style&index=0&id=0ef8a178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef8a178",
  null
  
)

export default component.exports